/**
 * Variant gallery filter
 * ----------------------
 * Images/media are tagged (via their Alt text in Shopify admin) with the
 * exact option value they belong to, e.g. an image alt of "Black" is
 * matched against a variant option value of "Black".
 *
 * On page load the Liquid templates already hide non-matching slides
 * for the default/selected variant (see product-info-media-style*.liquid
 * and product-info-media-mobile.liquid). This script keeps the gallery in
 * sync after that, whenever the shopper picks a different option value,
 * without a page reload.
 *
 * If a product has no media tagged with any option value, nothing is
 * hidden and the gallery behaves exactly as before.
 */
(function () {
  var HIDDEN_CLASS = 'is-variant-media-hidden';

  function getSelectedOptionValues() {
    var groups = document.querySelectorAll('xo-product-variant');
    var values = [];

    groups.forEach(function (group) {
      var checked = group.querySelector('input:checked');
      var value = checked ? checked.value : null;

      if (!value) {
        var select = group.querySelector('select');
        if (select) value = select.value;
      }

      if (value) values.push(value.trim().toLowerCase());
    });

    return values;
  }

  function filterGallery() {
    var selectedValues = getSelectedOptionValues();
    if (!selectedValues.length) return;

    var groups = document.querySelectorAll('[data-variant-gallery]');

    groups.forEach(function (group) {
      var items = group.querySelectorAll('[data-media-alt]');
      if (!items.length) return;

      // Only filter this gallery group if at least one of its items is
      // tagged with a value that matches one of the currently selected
      // options. Otherwise leave everything visible (untagged media).
      var hasTaggedMatch = Array.prototype.some.call(items, function (item) {
        var alt = item.getAttribute('data-media-alt');
        return alt && selectedValues.indexOf(alt) > -1;
      });

      items.forEach(function (item) {
        if (!hasTaggedMatch) {
          item.classList.remove(HIDDEN_CLASS);
          return;
        }
        var alt = item.getAttribute('data-media-alt');
        var matches = alt && selectedValues.indexOf(alt) > -1;
        item.classList.toggle(HIDDEN_CLASS, !matches);
      });
    });

    // Nudge the carousel web component (it observes size changes) to
    // recalculate slide widths/positions now that some slides are hidden.
    window.dispatchEvent(new Event('resize'));
  }

  document.addEventListener('change', function (event) {
    if (event.target.closest && event.target.closest('xo-product-variant')) {
      requestAnimationFrame(filterGallery);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', filterGallery);
  } else {
    filterGallery();
  }

  // Re-run inside the theme editor when this section is re-rendered.
  document.addEventListener('shopify:section:load', filterGallery);
})();
